import cc from 'classcat';

import { mergeStyles } from '#src/hooks/use-merged-styles.js';

import Container from '../../Container';
import { Copyright } from '../Copyright';

import { Category } from './Category';
import localStyles from './styles.module.scss';

export const Corporate = ({
  companyLegalName,
  copyrightStartYear,
  corporateFooterCategories,
  className,
  styles: stylesProp,
}) => {
  const styles = mergeStyles(localStyles, stylesProp);
  return (
    <footer className={cc([styles.footer, className])}>
      <Container className={styles.container}>
        <div className={styles.categoryContainer}>
          {corporateFooterCategories.map((category, index) => (
            <Category category={category} key={index} styles={styles} />
          ))}
        </div>
        <Copyright
          styles={styles}
          companyLegalName={companyLegalName}
          copyrightStartYear={copyrightStartYear}
        />
      </Container>
    </footer>
  );
};
